import "./About.module.css";
import Header from "@/reusable_sections/Header";
import CompanyHistory from "./sections/CompanyHistory";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <CompanyHistory />
      <Footer />
    </div>;
}